export default class Career {
    constructor(element) {
        this.element = element;
        this.abortController = null;
        this.linkSelector = [
            '.job-card-link',
            '.career-back-link'
        ].join(', ');

        this.handleClick = this.handleClick.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.init();
    }

    init() {
        document.body.addEventListener('click', this.handleClick);
        window.addEventListener('popstate', this.handlePopState);

        history.replaceState({ careerUrl: window.location.href }, '', window.location.href);
    }

    handleClick(event) {
        const link = event.target.closest(this.linkSelector);
        if (!link || link.classList.contains('disabled')) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.target === '_blank' || link.hasAttribute('download')) return;

        const targetUrl = link.href;
        if (!targetUrl || new URL(targetUrl, window.location.href).origin !== window.location.origin) return;

        event.preventDefault();
        this.navigate(targetUrl, { push: true, focus: true });
    }

    handlePopState() {
        this.navigate(window.location.href, { push: false, focus: false });
    }

    async navigate(targetUrl, { push, focus }) {
        this.abortController?.abort();
        const controller = new AbortController();
        this.abortController = controller;
        this.element.classList.add('is-loading');
        this.element.setAttribute('aria-busy', 'true');

        try {
            const response = await fetch(targetUrl, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: controller.signal
            });

            if (!response.ok) {
                throw new Error(`Career request failed with status ${response.status}`);
            }

            const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fragment = responseDocument.querySelector('[data-career-ajax-content]');

            if (!fragment) {
                throw new Error('Career response did not contain an AJAX fragment');
            }

            const isSingle = fragment.dataset.careerView === 'single';
            this.element.innerHTML = fragment.innerHTML;

            const page = this.element.closest('main');
            page?.classList.toggle('jobs-page', !isSingle);
            page?.classList.toggle('single-job-page', isSingle);

            if (fragment.dataset.pageTitle) {
                document.title = fragment.dataset.pageTitle;
            }

            if (push) {
                history.pushState({ careerUrl: targetUrl }, '', targetUrl);
            }

            // Les scripts injectés via innerHTML ne s'exécutent pas (ex. formulaire Zoho)
            this.runScripts();

            if (focus) {
                this.element.querySelector('[data-career-focus], h2')?.focus({ preventScroll: true });
                this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                window.location.href = targetUrl;
            }
        } finally {
            if (this.abortController === controller) {
                this.element.classList.remove('is-loading');
                this.element.removeAttribute('aria-busy');
            }
        }
    }

    runScripts() {
        this.element.querySelectorAll('script').forEach((oldScript) => {
            const script = document.createElement('script');
            for (const attribute of oldScript.attributes) {
                script.setAttribute(attribute.name, attribute.value);
            }
            script.textContent = oldScript.textContent;
            oldScript.replaceWith(script);
        });
    }
}
